import React, { FC } from 'react';
import { useSingleTemplateData } from '../../../hooks/useSingleTemplateData';
import { useTemplatesData } from '../../../hooks/useTemplatesData';
import { TemplatesGrid } from '../../CommonComponents/TemplatesGrid/TemplatesGrid';
import css from '../TemplatePage.scss';
import { Divider, Heading } from '@wix/design-system';
import { usePageNavigate } from '../../../hooks/usePageNavigate';
import { useTranslation } from '@wix/wix-i18n-config';
import { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

export const RelatedTemplates: FC = () => {
  const { t } = useTranslation();
  const { template } = useSingleTemplateData();
  const { templates } = useTemplatesData();
  const { navigateToTemplate } = usePageNavigate();
  const { reportRelatedTemplateClick } = useTemplatesPageBi();
  const relatedIds = template?.relatedTemplates;
  if (!relatedIds?.length) {
    return null;
  }
  const relatedTemplates = templates.filter((template) =>
    relatedIds.includes(template.id as string),
  );

  const onItemClick = (item: AppTemplate) => {
    reportRelatedTemplateClick(item.id);
    navigateToTemplate(item);
  };

  return (
    <>
      <div className={css.divider}>
        <Divider skin="light" />
      </div>
      <div className={css.relatedTemplatesWrapper}>
        <Heading size="large">
          {t('app.template-page.related-templates.title')}
        </Heading>
        <TemplatesGrid
          templates={relatedTemplates}
          onTemplateClick={onItemClick}
        />
      </div>
    </>
  );
};
